// import axios from 'axios';


export default {
  namespaced: true,
  
  state: {
    activeTab: 'payments',
    startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0], // Default to 1 month ago
    endDate: new Date().toISOString().split('T')[0], // Default to today
    selectedCompany: 'all',
    loading: false,
    error: null,

    isSuperAdmin: true,
    currentCompany: 'Bank A',

    companies: ['Bank A', 'Bank B', 'Bank C'],

    paymentSummary: {
      total: 245000,
      count: 42,
      pending: 35000,
      average: 5833.33
    },
    paymentsData: [
      {
        id: 'PMT-1001',
        date: '2023-10-01',
        recipient: 'Agent Smith',
        amount: 12500,
        company: 'Bank A',
        status: 'completed'
      },
      {
        id: 'PMT-1002',
        date: '2023-10-05',
        recipient: 'Agent Brown',
        amount: 9800,
        company: 'Bank B',
        status: 'completed'
      },
      {
        id: 'PMT-1003',
        date: '2023-10-10',
        recipient: 'Agent White',
        amount: 6400,
        company: 'Bank C',
        status: 'completed'
      },
      {
        id: 'PMT-1004',
        date: '2023-10-15',
        recipient: 'Agent Green',
        amount: 5200,
        company: 'Bank A',
        status: 'pending'
      },
      {
        id: 'PMT-1005',
        date: '2023-10-20',
        recipient: 'Agent Black',
        amount: 3800,
        company: 'Bank B',
        status: 'pending'
      }
    ],
    
    // Wallet data
    walletSummary: {
      totalFunding: 75000,
      totalDeductions: 45000,
      netChange: 30000,
      currentBalance: 125000
    },
    walletTransactions: [
      {
        id: 'TRX-1001',
        date: '2023-10-01',
        type: 'credit',
        amount: 25000,
        company: 'Bank A',
        description: 'Initial funding'
      },
      {
        id: 'TRX-1002',
        date: '2023-10-05',
        type: 'debit',
        amount: 12500,
        company: 'Bank A',
        description: 'Payment to Agent Smith'
      },
      {
        id: 'TRX-1003',
        date: '2023-10-15',
        type: 'credit',
        amount: 50000,
        company: 'Bank B',
        description: 'Additional funding'
      },
      {
        id: 'TRX-1004',
        date: '2023-10-20',
        type: 'debit',
        amount: 7500,
        company: 'Bank B',
        description: 'Payment to Supplier ABC'
      },
      {
        id: 'TRX-1005',
        date: '2023-10-25',
        type: 'debit',
        amount: 3000,
        company: 'Bank C',
        description: 'Payment to Contractor 123'
      }
    ],
    
    // Agent data
    agentSummary: {
      totalPayouts: 125000,
      agentCount: 15,
      averagePayout: 8333.33,
      transactionCount: 87
    },
    agentPayouts: [
      {
        id: 1,
        date: '2023-10-31',
        name: 'Agent Smith',
        transactionCount: 15,
        totalAmount: 125000,
        company: 'Bank A',
        commission: 6250
      },
      {
        id: 2,
        date: '2023-10-31',
        name: 'Agent Brown',
        transactionCount: 12,
        totalAmount: 98000,
        company: 'Bank B',
        commission: 4900
      },
      {
        id: 3,
        date: '2023-10-31',
        name: 'Agent White',
        transactionCount: 8,
        totalAmount: 64000,
        company: 'Bank C',
        commission: 3200
      },
      {
        id: 4,
        date: '2023-10-31',
        name: 'Agent Green',
        transactionCount: 7,
        totalAmount: 52000,
        company: 'Bank A',
        commission: 2600
      },
      {
        id: 5,
        date: '2023-10-31',
        name: 'Agent Black',
        transactionCount: 5,
        totalAmount: 38000,
        company: 'Bank B',
        commission: 1900
      }
    ],
    
    // Signup data
    signupSummary: {
      totalSignups: 125,
      pendingCount: 15,
      approvedCount: 98,
      rejectedCount: 12
    },
    signupsData: [
      {
        id: 'KYC-1001',
        date: '2023-10-01',
        customerName: 'John Doe',
        agent: 'Agent Smith',
        company: 'Bank A',
        status: 'Approved',
        processingTime: 24
      },
      {
        id: 'KYC-1002',
        date: '2023-10-02',
        customerName: 'Jane Smith',
        agent: 'Agent Brown',
        company: 'Bank B',
        status: 'Approved',
        processingTime: 18
      },
      {
        id: 'KYC-1003',
        date: '2023-10-03',
        customerName: 'Alice Johnson',
        agent: 'Agent White',
        company: 'Bank C',
        status: 'Rejected',
        processingTime: 12
      },
      {
        id: 'KYC-1004',
        date: '2023-10-04',
        customerName: 'Bob Williams',
        agent: 'Agent Green',
        company: 'Bank A',
        status: 'Pending',
        processingTime: 6
      },
      {
        id: 'KYC-1005',
        date: '2023-10-05',
        customerName: 'Charlie Brown',
        agent: 'Agent Black',
        company: 'Bank B',
        status: 'Approved',
        processingTime: 36
      }
    ],
    
    // Report settings
    reportSettings: {
      recipients: 'finance@company.com, admin@company.com',
      deliveryDay: '1',
      formats: ['pdf', 'excel'],
      includedReports: ['payments', 'wallet', 'agent', 'signup']
    }
  },
  
  getters: {
    reportPeriod: (state) => {
      return `${formatDate(state.startDate)} - ${formatDate(state.endDate)}`;
    },
    
    // Helper function for formatting dates
    formatDate: () => (date) => {
      return new Date(date).toLocaleDateString();
    },
    
    // Helper function for formatting currency
    formatCurrency: () => (amount) => {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'ZMW'
      }).format(amount);
    }
  },
  
  mutations: {
    setActiveTab(state, tab) {
      state.activeTab = tab;
    },
    
    setDateRange(state, { startDate, endDate }) {
      if (startDate) state.startDate = startDate;
      if (endDate) state.endDate = endDate;
    },
    
    setSelectedCompany(state, company) {
      state.selectedCompany = company;
    },
    
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    
    setError(state, error) {
      state.error = error;
    },
    
    setReportSettings(state, settings) {
      state.reportSettings = { ...state.reportSettings, ...settings };
    },
    
    // Update data based on report generation
    setReportData(state, { paymentSummary, paymentsData, walletSummary, walletTransactions, 
                          agentSummary, agentPayouts, signupSummary, signupsData }) {
      if (paymentSummary) state.paymentSummary = paymentSummary;
      if (paymentsData) state.paymentsData = paymentsData;
      if (walletSummary) state.walletSummary = walletSummary;
      if (walletTransactions) state.walletTransactions = walletTransactions;
      if (agentSummary) state.agentSummary = agentSummary;
      if (agentPayouts) state.agentPayouts = agentPayouts;
      if (signupSummary) state.signupSummary = signupSummary;
      if (signupsData) state.signupsData = signupsData;
    }
  },
  
  actions: {
    async generateReport({ commit, state }) {
      commit('setLoading', true);
      try {
        console.log('Generating report for:', state.startDate, 'to', state.endDate);
        console.log('Selected company:', state.selectedCompany);
        console.log('Active tab:', state.activeTab);
        
        // In a real implementation, this would call an API to get the report data
        // const response = await axios.get(`${apiBaseUrl}/reports/generate`, {
        //   params: {
        //     startDate: state.startDate,
        //     endDate: state.endDate,
        //     company: state.selectedCompany,
        //     reportType: state.activeTab
        //   }
        // });
        
        // For now, we'll just use the mock data that's already in the state
        // In a real app, you would update the state with the response data
        // commit('setReportData', response.data);
        
        return true;
      } catch (error) {
        console.error('Error generating report:', error);
        errorHandler.tomcatError(error)
        return false;
      } finally {
        commit('setLoading', false);
      }
    },
    
    async exportReport({ state }, format) {
      try {
        console.log('Exporting report as:', format);
        
        // In a real implementation, this would call an API to get the exported report
        // const response = await axios.get(`${apiBaseUrl}/reports/export`, {
        //   params: {
        //     startDate: state.startDate,
        //     endDate: state.endDate,
        //     company: state.selectedCompany,
        //     reportType: state.activeTab,
        //     format: format
        //   },
        //   responseType: 'blob'
        // });
        
        // // Create a download link for the exported file
        // const url = window.URL.createObjectURL(new Blob([response.data]));
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', `financial-report.${format}`);
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        
        return true;
      } catch (error) {
        console.error('Error exporting report:', error);
        errorHandler.tomcatError(error)
        return false;
      }
    },
    
    async saveReportSettings({ commit, state }, settings) {
      try {
        console.log('Saving report settings:', settings);
        
        // In a real implementation, this would call an API to save the settings
        // await axios.post(`${apiBaseUrl}/reports/settings`, settings);
        
        // Update the state with the new settings
        commit('setReportSettings', settings);
        
        return true;
      } catch (error) {
        console.error('Error saving report settings:', error);
        errorHandler.tomcatError(error)
        return false;
      }
    }
  }
};

// Helper function for formatting dates
function formatDate(date) {
  return new Date(date).toLocaleDateString();
} 